import {type FC, memo} from "react";

import type {Tax} from "./types";

import {Table, TableCell, TableHeader, TableRow} from "@/client/components/Table";
import TableCellEditRemoveActions from "@/client/components/Table/TableCellEditRemoveActions";

interface Props {
    taxes: Tax[];
    onEdit: (tax: Tax) => void;
    onRemove: (idx: number) => void;
}

const TaxList: FC<Props> = ({taxes, onEdit, onRemove}) => {
    return (
        <Table size="sm">
            <TableRow>
                <TableHeader>Tax Name</TableHeader>
                <TableHeader>Type</TableHeader>
                <TableHeader>Percent</TableHeader>
                <TableHeader align="end">Action</TableHeader>
            </TableRow>
            {taxes.map((tax, idx) => (
                <TableRow key={tax.name}>
                    <TableCell>{tax.name}</TableCell>
                    <TableCell>{tax.type ? tax.type : "-"}</TableCell>
                    <TableCell>{tax.value}</TableCell>
                    <TableCell align="end">
                        <TableCellEditRemoveActions
                            id={idx}
                            item={tax}
                            onEdit={onEdit}
                            onRemove={onRemove}
                        />
                    </TableCell>
                </TableRow>
            ))}
        </Table>
    );
};

export default memo(TaxList);
